var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.052,
    height: 85.309,
    viewBox: "0 0 99.052 85.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-device",
    "data-name": "002-device",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M37.436,280.323a1.178,1.178,0,0,0,0,2.356h.018a1.17,1.17,0,0,0,1.169-1.178A1.186,1.186,0,0,0,37.436,280.323Z",
    transform: "translate(-30.121 -233.143)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 1.742,
    cy: 1.742,
    r: 1.742,
    transform: "translate(10.709 77.613)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M410.415,440.347H407.56a1.178,1.178,0,1,0,0,2.356h2.855a1.178,1.178,0,1,0,0-2.356Z",
    transform: "translate(-327.583 -361.752)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M377.775,274.989H353.82a1.178,1.178,0,0,0-1.178,1.178v6.984a1.178,1.178,0,1,0,2.356,0v-5.807h21.6v26.914H355V291a1.178,1.178,0,1,0-2.356,0v14.433a1.178,1.178,0,0,0,1.178,1.178h23.955a1.178,1.178,0,0,0,1.178-1.178v-29.27A1.178,1.178,0,0,0,377.775,274.989Z",
    transform: "translate(-284.393 -228.856)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M225.763,292.993a2.792,2.792,0,1,0-2.792-2.792A2.792,2.792,0,0,0,225.763,292.993Zm0-3.227a.436.436,0,1,1-.436.436A.436.436,0,0,1,225.763,289.766Z",
    transform: "translate(-180.179 -238.839)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M225.749,365.559h-.077a1.178,1.178,0,1,0,0,2.356h.077a1.178,1.178,0,0,0,0-2.356Z",
    transform: "translate(-181.403 -301.646)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M99.712,81.742H88.8V44.405A4.411,4.411,0,0,0,84.392,40H17.736a4.411,4.411,0,0,0-4.406,4.405V81.5H9.184A4.188,4.188,0,0,0,5,85.679v34.948a4.188,4.188,0,0,0,4.184,4.183H25.718a4.188,4.188,0,0,0,4.184-4.183V98.189H40.528v3.675a2.052,2.052,0,0,1-2.05,2.05,6.027,6.027,0,0,0-6.02,6.019,1.178,1.178,0,0,0,1.178,1.178h33.9a1.178,1.178,0,0,0,1.178-1.178,6.027,6.027,0,0,0-5.73-6.011,1.215,1.215,0,0,0-.129-.007H62.69a2.052,2.052,0,0,1-2.05-2.05V98.189h8.616v22.782a3.843,3.843,0,0,0,3.84,3.839H99.712a3.844,3.844,0,0,0,3.84-3.839V85.581a3.844,3.844,0,0,0-3.84-3.839ZM27.546,120.626a1.83,1.83,0,0,1-1.828,1.827H9.184a1.83,1.83,0,0,1-1.828-1.827v-3.987h20.19Zm0-33.447H15.774a1.178,1.178,0,0,0,0,2.356H27.546v24.748H7.356V89.536H8.93a1.178,1.178,0,0,0,0-2.356H7.356v-1.5a1.83,1.83,0,0,1,1.828-1.828H25.718a1.83,1.83,0,0,1,1.828,1.828Zm35.144,19.089a3.671,3.671,0,0,1,3.47,2.485H35.007a3.671,3.671,0,0,1,3.47-2.485,4.411,4.411,0,0,0,4.406-4.405V98.189h15.4v3.675a4.376,4.376,0,0,0,.507,2.049H53.375a1.178,1.178,0,1,0,0,2.356ZM69.4,84.537H41.935a1.178,1.178,0,1,0,0,2.356H69.256v8.941H29.9v-8.94h4.18a1.178,1.178,0,0,0,0-2.356H29.739A4.188,4.188,0,0,0,25.718,81.5H15.686V44.405a2.052,2.052,0,0,1,2.05-2.049H84.392a2.052,2.052,0,0,1,2.05,2.049V81.742H73.1A3.844,3.844,0,0,0,69.4,84.537ZM101.2,120.971a1.485,1.485,0,0,1-1.484,1.483H73.1a1.485,1.485,0,0,1-1.484-1.483V85.581A1.485,1.485,0,0,1,73.1,84.1H99.712a1.485,1.485,0,0,1,1.484,1.483Z",
    transform: "translate(-5 -40)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronica);
export default __webpack_public_path__ + "static/media/electronica.aea8e71cfa4ca30532c3182af0ab8890.svg";
export { ForwardRef as ReactComponent };